import { Col } from "react-bootstrap";
import { IPropertyTaxModel } from "../../Types/PropertyTaxTypes";
import { usePropertyTaxConfig } from "../../common/config/configHooks";
import { toCurrency } from "../../common/utilities/parser";
import { useMunicipality } from "../../Contexts/MunicipalityKey";

export type PropertyTaxViewProp = {
  data: IPropertyTaxModel;
  showHeader: boolean;
};

export function PropertyTaxDetails(props: PropertyTaxViewProp) {
  const municipality = useMunicipality();
  const estatePropertyTaxUrl = usePropertyTaxConfig()?.propertyTaxUrl || undefined;

  if (!!!props.data)
    return (
      <>Fant ingen eiendomsskatt registrert på dette gårds- og bruksnummeret.</>
    );

  return (
    <div className="container p-0">
      <div id="propertyTaxContainer">
        <br />
        {municipality.name === "risor" && (
          <h3>Utregning kan vise feil, spesielt for fritidseiendommer, henviser til skatteseddel for fullstendig oversikt.</h3>
        )}
        <h3>Slik beregnes eiendomsskatten</h3>
        <Col lg={{ span: 5 }} xs={{ span: 12 }} className="p-0">
          <table className="tax-calculation">
            <tbody>
              <tr className="calculation-row">
                <th>Eiendommens fastsatte verdi</th>
                <td>
                  {toCurrency(props.data.takst)}
                </td>
              </tr>
              {props.data.reduksjonsfaktor !== null && (
                <tr className="calculation-row">
                  <th>* Reduksjonsfaktor</th>
                  <td>{props.data.reduksjonsfaktor} %</td>
                </tr>
              )}
              {props.data.reduksjonsverdi !== null && (
                <tr className="calculation-row">
                  <th>- Reduksjonsverdi</th>
                  <td>
                    {toCurrency(Math.abs(props.data.reduksjonsverdi))}
                  </td>
                </tr>
              )}
              <tr className="calculation-row">
                <th>- Bunnfradrag</th>
                <td>
                  {toCurrency(props.data.bunnfradrag)}
                </td>
              </tr>
              <tr className="sum">
                <th>= Grunnlag for eiendomsskatt</th>
                <td>
                  {toCurrency(props.data.skattegrunnlag)}
                </td>
              </tr>
              <tr className="calculation-row">
                <th>* Skattesats</th>
                <td>{props.data.promille} ‰</td>
              </tr>
              <tr className="sum">
                <th className="font-weight-bold">= Eiendomsskatt {props.data.arstall}:</th>
                <td className="font-weight-bold">
                  {toCurrency(props.data.beregnetSkatt)}
                </td>
              </tr>
              <tr className="calculation-row">
                <td colSpan={2}>
                  <div className="double-line"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
        {estatePropertyTaxUrl && (
          <>
            <br />
            <h3>Har du spørsmål?</h3>
            <p>
              Du finner <a href={estatePropertyTaxUrl}>kontaktinfo og mer om eiendomsskatt</a> på vår nettside.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
